import React from 'react';
import { Mail, Linkedin, ArrowUpRight } from 'lucide-react';
import Reveal from '../components/Reveal';
import PageHeader from '../components/PageHeader';
import { images, company } from '../mock';

const Contact = () => {
  return (
    <div>
      <PageHeader
        eyebrow="Contact"
        title="Get in touch"
        subtitle="For partnership and investment inquiries regarding Whitemoon Magnesium."
        image={images.desertMountain}
      />

      <section className="py-28 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-16 items-start">
          <div className="lg:col-span-5">
            <Reveal>
              <div className="eyebrow text-amber-700 mb-4">Reach us</div>
              <h2 className="font-display text-3xl md:text-4xl font-medium text-neutral-900 leading-tight">
                Let's talk about American magnesium.
              </h2>
              <p className="mt-6 text-neutral-600 leading-relaxed">
                We welcome conversations with investors, industry partners and stakeholders interested in domestic critical-mineral supply.
              </p>
            </Reveal>
          </div>

          <div className="lg:col-span-7 lg:pt-7">
            <div className="space-y-6">
              <Reveal>
                <a
                  href={`mailto:${company.email}`}
                  data-testid="contact-email-row"
                  className="group flex items-center justify-between gap-4 border-t border-neutral-200 pt-6 hover:text-amber-700 transition-colors"
                >
                  <div className="flex items-start gap-4">
                    <Mail className="w-5 h-5 text-amber-700 mt-1" strokeWidth={1.5} />
                    <div>
                      <div className="eyebrow text-neutral-500 text-[0.6rem]">Email</div>
                      <div className="text-neutral-900 group-hover:text-amber-700 text-lg mt-1 transition-colors">{company.email}</div>
                    </div>
                  </div>
                  <ArrowUpRight className="w-5 h-5 text-neutral-400 group-hover:text-amber-700 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all duration-300" />
                </a>
              </Reveal>

              <Reveal delay={100}>
                <a
                  href={company.linkedin}
                  target="_blank"
                  rel="noreferrer"
                  data-testid="contact-linkedin-row"
                  className="group flex items-center justify-between gap-4 border-t border-neutral-200 pt-6 hover:text-amber-700 transition-colors"
                >
                  <div className="flex items-start gap-4">
                    <Linkedin className="w-5 h-5 text-amber-700 mt-1" strokeWidth={1.5} />
                    <div>
                      <div className="eyebrow text-neutral-500 text-[0.6rem]">LinkedIn</div>
                      <div className="text-neutral-900 group-hover:text-amber-700 text-lg mt-1 transition-colors">Whitemoon Magnesium</div>
                    </div>
                  </div>
                  <ArrowUpRight className="w-5 h-5 text-neutral-400 group-hover:text-amber-700 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all duration-300" />
                </a>
              </Reveal>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
